import request from '../request';

export function fetch({ profile }: { profile: string }) {
  return [request, 'get', `profiles/${profile}`, { profile }]; // passing { profile } as params required for cache validation
}

export function fetchParameters({ paths }: { paths: string[] }) {
  return [request, 'post', 'search/metadata', { path: paths }];
}
